import apiClient from '@u/apiClient'
import GetWikiPlaceByIdController from '@/wayfinder/actions/App/Http/Controllers/WikiPlace/GetWikiPlaceByIdController'
import GetItemsByPlacesController from '@/wayfinder/actions/App/Http/Controllers/WikiPlace/GetItemsByPlacesController'
import CreateWikiPlaceController from '@/wayfinder/actions/App/Http/Controllers/WikiPlace/CreateWikiPlaceController'
import UpdatePlaceController from '@/wayfinder/actions/App/Http/Controllers/WikiPlace/UpdatePlaceController'
import GetPlaceListForSelectController from '@/wayfinder/actions/App/Http/Controllers/WikiPlace/GetPlaceListForSelectController'
import GetPlacesWithRoomsListForSelectController from '@/wayfinder/actions/App/Http/Controllers/WikiPlace/GetPlacesWithRoomsListForSelectController'
import GetWikiPlaceAsMarkerController from '@/wayfinder/actions/App/Http/Controllers/WikiPlace/GetWikiPlaceAsMarkerController'
import GetWikiPlaceForMarkerController from '@/wayfinder/actions/App/Http/Controllers/WikiPlace/GetWikiPlaceForMarkerController'
import GetNewWikiPlaceController from '@/wayfinder/actions/App/Http/Controllers/WikiPlace/GetNewWikiPlaceController'
import UpdatePlaceEnaosIdController from '@/wayfinder/actions/App/Http/Controllers/WikiPlace/UpdatePlaceEnaosIdController'
import GetNewModelController from '@/wayfinder/actions/App/Http/Controllers/NewModel/GetNewModelController'
import GetPlacesByCityAndRelationController from '@/wayfinder/actions/App/Http/Controllers/WikiPlace/GetPlacesByCityAndRelationController'
import DeleteWikiPlaceController from '@/wayfinder/actions/App/Http/Controllers/WikiPlace/DeleteWikiPlaceController'
let base_errors = {}
function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}
export default {
  async fetchNewPlace({ commit }, payload) {
    commit('setItemList', [])
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(GetNewModelController.get({ query: { model: 'wikiplace' } }))
      .then(async (response) => {
        await console.log('', response)
        if (response.status === 200) {
          if (payload.type) response.data.wikiplace.type = payload.type
          if (payload.city_id) response.data.wikiplace.city_id = payload.city_id
          commit('setPlace', response.data.wikiplace)
        }
      })
      .catch(async (reason) => {
        await console.error('', reason)
      })
  },
  async fetchPlacesByType({ commit }, payload) {
    commit('setItemList', [])
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(GetWikiPlaceByIdController.get({ place_id: payload.place_type }))
      .then(async (response) => {
        if (response.status === 200) {
          commit('setPlaceList', response.data.places)
        }
      })
      .catch(async (reason) => {
        await console.error('fetchPlacesByType', reason)
      })
  },
  async fetchFetchItemsByPlace({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetItemsByPlacesController.get({ place: payload.place_id }), {
          params: {
            ...(payload.dossier_id ? { dossier: payload.dossier_id } : {}),
            // lets the API tell, per item, which wiki price applies (resident or not)
            ...(payload.price_dossier_id
              ? { price_dossier: payload.price_dossier_id }
              : {})
          }
        })
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          await console.error('fetchFetchItemsByPlace', reject(reason))
        })
    })
  },
  async fetchPlaceByIdAndType({ commit }, payload) {
    commit('setItemList', [])
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(
        GetWikiPlaceByIdController.get(
          { place_id: payload.place_id },
          { query: { type: payload.type } }
        )
      )
      .then(async (response) => {
        if (response.status === 200) {
          commit('setPlace', response.data.place)
        }
      })
      .catch(async (reason) => {
        await console.error('fetchPlaceByIdAndType', reason)
      })
  },

  storePlace: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(CreateWikiPlaceController.post(), payload.place)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  updatePlace: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdatePlaceController.put({ place: payload.place_id }),
          payload.place
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  async fetchPlacesByCityAndRelation({ commit }, payload) {
    commit('setPlaceList', [])
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(
        GetPlacesByCityAndRelationController.get(
          { city: payload.city_id },
          { query: { type: payload.type } }
        )
      )
      .then(async (response) => {
        if (response.status === 200) {
          commit('setPlaceList', response.data.places)
        }
      })
      .catch(async (reason) => {
        await console.error('', reason)
      })
  },
  async fetchWikiPlaceByType({}, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetPlaceListForSelectController[
            '/api/place-for-select/{place_type}'
          ].get({ place_type: payload.type }),
          {
            params: payload
          }
        )
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  async fetchWikiPlaceWithRoomsByType({}, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetPlacesWithRoomsListForSelectController.get({
            place_type: payload.type
          }),
          {
            params: payload
          }
        )
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  async deleteWikiPlaceById({ commit }, payload) {
    await apiClient
      .route(
        DeleteWikiPlaceController.delete.delete(
          { wiki_place: payload.place_id },
          { query: { type: payload.place_type } }
        )
      )
      .then(async (response) => {
        if (response.status === 200) {
          commit('setPlaceList', response.data.places)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        await console.error('deleteWikiPlaceById', reason)
      })
  },
  async undoDeleteWikiPlaceById({ commit }, payload) {
    await apiClient
      .route(
        DeleteWikiPlaceController.undo.get(
          { wiki_place: payload.place_id },
          { query: { type: payload.place_type } }
        )
      )
      .then(async (response) => {
        if (response.status === 200) {
          await commit('setPlaceList', response.data.places)
        }
        processSuccessCallback(payload)
      })
      .catch(async (reason) => {
        await console.error('undoDeleteWikiPlaceById', reason)
      })
  },
  getMarkersArround({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetWikiPlaceAsMarkerController.get(), {
          params: payload
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  getMarkerInfo({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetWikiPlaceForMarkerController.get({ wiki_place: payload.place_id })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchPlaceInfo({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetWikiPlaceByIdController.get({ place_id: payload.place_id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchNewPlace2({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetNewWikiPlaceController.get(), {
          params: {
            city_id: payload?.city_id ?? null
          }
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  updateEnaosId({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdatePlaceEnaosIdController.put({ wiki_place: payload.place_id }),
          { enaos_id: payload.enaos_id }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
